/**
 * Makes sure whatever is passed in is an array when returned. Maintains
 * type information.
 *
 * @param potentialArray
 */
export function coerceArray<T>(potentialArray?: T | T[]): T[] {
  if (!potentialArray) {
    return [];
  }
  if (Array.isArray(potentialArray)) {
    return potentialArray;
  }
  return [potentialArray];
}
